import * as swcHelpers from '@swc/helpers';
import { INIT } from './actions.js';

function apiConfigReducer(state = null, action) {
    switch(action.type){
        case INIT:
            return swcHelpers.objectSpread({}, state, action.payload);
        default:
            return state;
    }
}

export { apiConfigReducer as default };
//# sourceMappingURL=reducer.js.map
